import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Location } from '@angular/common';

import { Store } from '@ngrx/store';
import { Subject, filter, takeUntil } from 'rxjs';
import { selectCurrentRoute } from '@public-page/store/router';

import { GlobalService } from '@modules/core/services';

export interface CustomRouteData {
  title: string;
  backButtonTitle: string;
  backButtonRoute?: {
    path: Array<string>;
    queryParams?: string;
  };
}

@Component({
  selector: 'pub-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent implements OnInit, OnDestroy {
  @Input() isMobile = false;
  private destroyed$: Subject<boolean> = new Subject();
  currentRoute$ = this.store.select(selectCurrentRoute).pipe(takeUntil(this.destroyed$));
  currentRouteData!: CustomRouteData;
  currentRoute!: ActivatedRouteSnapshot;
  companyUuid!: string;

  constructor(
    public router: Router,
    private store: Store,
    private globalService: GlobalService,
    private cdRef: ChangeDetectorRef,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.currentRoute$.pipe(filter((val) => val !== undefined)).subscribe((route) => {
      this.currentRouteData = route.data;
      this.currentRoute = route;
      this.companyUuid = route.params.companyUuid;

      this.cdRef.detectChanges();
    });
  }

  get backButtonTitle(): string {
    return this.isMobile ? 'bookingPage.selectServicesPage.backButton' : this.currentRouteData?.backButtonTitle;
  }

  back(): void {
    const queryParams: { [key: string]: string } = {};
    this.currentRouteData.backButtonRoute?.queryParams?.split(',').forEach((value) => {
      const queryParamName = value.trim() as string;
      queryParams[queryParamName] = this.currentRoute.queryParams[queryParamName] ?? null;
    });

    const options = { queryParams };

    if (this.currentRouteData.backButtonRoute) {
      if (this.globalService.hasCustomDomain) {
        this.router.navigate([...this.currentRouteData.backButtonRoute.path], options);
      } else {
        this.router.navigate([this.companyUuid, ...this.currentRouteData.backButtonRoute.path], options);
      }
    } else {
      this.location.back();
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
